import { RefObject, useEffect } from 'react';

type ScrollOptions = {
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
  delay?: number;
  condition?: boolean;
};

type ScrollTarget = RefObject<HTMLElement> | string | null;

export function useScrollIntoView(
  target: ScrollTarget,
  options: ScrollOptions = {},
) {
  const {
    behavior = 'smooth',
    block = 'nearest',
    delay = 100,
    condition = true,
  } = options;

  useEffect(() => {
    if (!condition || !target) return;

    const timeoutId = setTimeout(() => {
      if (typeof target === 'string') {
        handleElementIdScroll(target);
      } else {
        handleRefScroll(target);
      }
    }, delay);

    return () => clearTimeout(timeoutId);

    function handleElementIdScroll(elementId: string) {
      const element = document.getElementById(elementId);
      if (element && typeof element.scrollIntoView === 'function') {
        element.scrollIntoView({
          behavior,
          block,
        });
      }
    }

    function handleRefScroll(ref: RefObject<HTMLElement>) {
      if (ref.current && typeof ref.current.scrollIntoView === 'function') {
        ref.current.scrollIntoView({
          behavior,
          block,
        });
      }
    }
  }, [target, condition, behavior, block, delay]);
}
